import React from "react"

import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

import "./cardTestimony.scss"

interface CardTestimonyInter {
  testimony: any
}

const cardTestimony = (props: CardTestimonyInter) => {
  const { testimony } = props

  return (
    <div className="a-testimonycard-container">
      <div className="a-testimonycard-firstline">
        <div className="a-testimonycard-pic">
          <img src={testimony && testimony.imagenPrincipal.url} alt={testimony && testimony.imagenPrincipal.alt} />
        </div>
        <div className="a-testimonycard-info">
          <div className="a-testimonycard-info--name">
            <p>{testimony && testimony.tituloBanner}</p>
          </div>
          <div className="a-testimonycard-info--age">
            <p>{testimony && testimony.tituloDescripcion}</p>
          </div>
        </div>
      </div>
      <div className="a-testimonycard-testimony">
        {documentToReactComponents(testimony && testimony.descripcion.json)}
      </div>

      <div className='icon-quote-left a-testimonycard-left'></div>
      <div className='icon-quote-right a-testimonycard-right'></div>
    </div>
  )
}

export default cardTestimony
